/* eslint-disable */
export default {
  _finish_line: 'finish-line',
  _truck_body_small: 'truck-body-small',
  _airplane_large: 'airplane-large',
  _card_bg: 'card-bg',
  _place_marker: 'place-marker',
  _truck_body_large: 'truck-body-large',
  _truck_wheel_small: 'truck-wheel-small',
  _truck_wheel_large: 'truck-wheel-large',
  _btn_next: 'btn-next',
  _airplane_small: 'airplane-small',
}